export const feedbackKeys = {
  all: ["feedback"] as const,
  links: () => [...feedbackKeys.all, "links"] as const,
};
